export const enum QueryKeyName {
	FirstSourceEvents = 'FirstSourceEvents',
	SecondSourceEvents = 'SecondSourceEvents'
}
